import React from "react";
import { useI18n } from "../i18n";
import { MEDIA } from "../constants";

export default function About() {
  const { t } = useI18n();

  return (
    <section
      id="about"
      className="relative py-24 md:py-32 border-t border-[#2d2622]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Image */}
        <div className="lg:col-span-5 relative order-2 lg:order-1">
          <div className="aspect-[4/5] overflow-hidden">
            <img
              src={MEDIA.gallery_interior}
              alt="TINTA intimate interior"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="hidden md:block absolute -bottom-8 -right-8 w-48 h-48 border border-[#d4af37]/40 pointer-events-none" />
        </div>

        {/* Content */}
        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-6">
            <div className="divider-gold" />
            <span className="overline">{t.about.overline}</span>
          </div>

          <h2
            className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-light leading-tight text-[#f4f0eb]"
            data-testid="about-title"
          >
            {t.about.title}
          </h2>

          <div className="mt-8 space-y-5 text-[#a39e97] text-base md:text-lg leading-relaxed max-w-2xl">
            <p data-testid="about-p1">{t.about.p1}</p>
            <p data-testid="about-p2">{t.about.p2}</p>
          </div>

          {/* Stats */}
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              { num: t.about.stat_1_num, label: t.about.stat_1_label, id: "rating" },
              { num: t.about.stat_2_num, label: t.about.stat_2_label, id: "followers" },
              { num: t.about.stat_3_num, label: t.about.stat_3_label, id: "discount" },
            ].map((s) => (
              <div
                key={s.id}
                className="border-t border-[#2d2622] pt-5"
                data-testid={`about-stat-${s.id}`}
              >
                <div className="font-serif-display text-4xl md:text-5xl text-[#d4af37] font-light">
                  {s.num}
                </div>
                <div className="mt-2 text-xs uppercase tracking-[0.2em] text-[#a39e97]">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
